import React from "react";
import { CiStar } from "react-icons/ci";
import SVG from '../../assets/SVG.png';
import SVG1 from '../../assets/SVG1.jpg';
import SVG2 from '../../assets/SVG2.png';
import mes from '../../assets/mes.png';

import { CiGift } from "react-icons/ci";
import Badges from "./Badges";
// Composant pour les icônes
const Icone = ({ icon, color }) => (
  <div className={`rounded-full flex items-center justify-center ${color}`}>
    {icon}
  </div>
);

// Composant pour les cartes
const Carte = ({ bgColor, icon, titre, texte, textPosition, width }) => (
  <div className={`flex flex-col items-center p-4 rounded-xl shadow-md ${bgColor}`}>
    <Icone icon={icon} color={width} />
    <h3 className="font-semibold mt-2 text-black">{titre}</h3>
    <p className={`text-graybadge mt-1 text-sm ${textPosition}`}>{texte}</p>
  </div>
);

// Composant pour les sections avec des titres
const SectionTitre = ({ grandTitre }) => (
  <div className="text-center my-8">
    <h2 className="text-2xl font-semibold text-noirel">{grandTitre}</h2>
  </div>
);

const Gamification = () => {
  return (
    <div className=" w-[90%] mx-auto py-12">
      {/* Titre principal */}
      <h1 className="text-[2.8rem] max-xl:text-4xl max-lg:text-xl antialiased font-semibold font-inter text-noirel max-sm:text-lg text-center mt-8">
        Système de Gamification Bakeli
      </h1>

      {/* Section des badges */}
      <SectionTitre className="text-xs" grandTitre="Système de Badges" />

      {/* Cartes des badges */}
      <Badges />
      {/********************************************************** */}
      {/* Classements et Palmarès */}


      <SectionTitre grandTitre="Classements et Palmarès" />
      {/* Cartes des classements */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        <Carte
          bgColor="!p-6"
          width={"!w-full"}
          icon={
            <div className="flex items-center gap-2  w-full">
              <img src={SVG1} alt="Classement Hebdomadaire" className="size-6" />
              <h3 className="font-semibold ml-2 text-black">
                Classements Hebdomadaires
              </h3>
            </div>
          }
          texte="Basés sur le nombre et la qualité des tâches terminées chaque semaine"
        />
        <Carte
          bgColor="!p-6"
          width="!w-full"
          icon={
            <div className="flex items-center gap-2 w-full">
              <img src={SVG2} alt="Classement par Compétences" className="size-6" />
              <h3 className="font-semibold ml-2 text-black">
                Classement par Compétences
              </h3>
            </div>
          }
          texte="Mesurez-vous aux autres dans votre domaine d'expertise spécifique"
        />
        <Carte
          bgColor="!p-6"
          width={"w-full"}
          icon={
            <div className="flex items-center gap-2  w-full">
              <img src={SVG} alt="Challenges Spéciaux" className="size-7 rounded-full" />
              <h3 className="font-semibold text-black">Challenges Spéciaux</h3>
            </div>
          }
          texte="Compétitions mensuelles avec badges exclusifs pour les meilleurs Bakelistes"
        />
      </div>

      {/********************************************************** */}
      {/* Système de Points */}
      <SectionTitre grandTitre="Système de Points" />

      <div className="bg-white shadow-md p-4 mt-8 flex flex-col justify-center rounded-xl">
        <div className="flex flex-col md:flex-row justify-center items-center gap-3 ">
          <div className="text-center  w-full md:w-[30%] flex flex-col gap-2">
            <h3
              className="text-base md:text-2xl font-semibold text-orange "
              style={{ color: "orange" }} >
              10pts
            </h3>
            <p className="text-gray-500 mt-0 text-sm ">Tâches Simples</p>
          </div>
          <div className="text-center w-full md:w-[30%] flex flex-col gap-2">
            <h3
              className="text-base  md:text-2xl font-semibold text-orange mx-2"
              style={{ color: "orange" }}>
              20pts
            </h3>
            <p className="text-gray-500 mt-0 text-sm ">Tâches Moyennes</p>
          </div>
          <div className="text-center w-full md:w-[30%] flex flex-col gap-2">
            <h3
              className="text-base md:text-2xl font-semibold text-orange mx-2"
              style={{ color: "orange" }} >
              50pts
            </h3>
            <p className="text-gray-500 mt-0 text-sm">Tâches Complexes</p>
          </div>
        </div>

        <div className="text-center text-sm mt-4 text-gray-500">
          Gagner des points en terminant des tâches, en recevant des retours
          positifs et en respectant les détails.
        </div>
      </div>

      {/********************************************************** */}
      {/* Récompenses */}
      <SectionTitre className="color-noir" grandTitre="Récompenses" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-8">
        <Carte
          width="w-full"
          textPosition="w-full"
          bgColor={"bg-white !p-6"}
          icon={
            <div className="flex gap-2 justify-start items-center w-full">
              <CiGift
                className="text-red-500 size-6"
                style={{ color: "red" }}
              />
              <h3 className=" font-semibold text-black ">
                Récompenses Tangibles
              </h3>
            </div>
          }
          texte="Bon d'achat, formations gratuites et primes financières pour les niveaux supérieurs"
        />
        <Carte
          width="w-full"
          textPosition="w-full"
          bgColor={"bg-white !p-6"}
          icon={
            <div className="flex gap-2 justify-start items-center w-full">
              <CiStar className="text-yellow-600 size-6" />
              <h3 className=" font-semibold text-black whitespace-nowrap">
                Accès Exclusif
              </h3>
            </div>
          }
          texte="Tâches premium et meilleure visibilité pour les badges Or et Platine"
        />
      </div>

      {/********************************************************** */}
      {/* Boucle de Feedback */}
      <SectionTitre className="color-noir" grandTitre="Boucle de Feedback" />

      <div className="bg-white rounded-lg shadow-md p-6 text-center mt-8">
        <div className="flex flex-col items-center">

          <img src={mes} alt="Classement Hebdomadaire" className="size-14" />
          <p className="text-graybadge mt-2 text-sm">
            Les évaluations des coachs et des clients influencent votre
            classement et l'acquisition de badges. Un feedback constructif
            assure une amélioration continue et maintient la motivation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gamification;
